import React, { useState, useRef, useEffect } from "react";
import "./modalComponent.css";
import "../Menu/addMore/orderModal.css";
import copy from "../../../Assets/copy.svg";
import convertToIST from "../../../services/istTime";
import api from "../../../services/api";
import { useToast } from "../../../mesageToast/ToastContainer";
import { useDispatch } from "react-redux";
import { updateOrderDine } from "../../../redux/Slice/OrderSlice";
import cross from "../../../Assets/cross.svg";

function EditDetailsDineIn({
  isOpen,
  onClose,
  refresh,
  onRejectClicked,
  order,
}) {
  const currency = "₹";
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const [tableNumber, setTableNumber] = useState("");
  const [staffError, setStaffError] = useState(false);
  const [tableError, setTableError] = useState(false);
  const addToast = useToast();

  const handleTableChange = (e) => {
    setTableNumber(e.target.value);
    setTableError(false);
  };

  const handleCopy = (orderId) => {
    navigator.clipboard.writeText(orderId.toString());
    alert(`Order ID #${orderId} copied to clipboard!`);
  };

  const handleAccept = () => {
    let error = false;

    // if (!staffName) {
    //   setStaffError(true);
    //   error = true;
    // }
    if (!tableNumber) {
      setTableError(true);
      error = true;
    }

    if (error) {
      return;
    }
     // Check if the table number is actually updated
    if (tableNumber === order?.user?.tableNo) {
      addToast(
        "No Updates",
        "Order details remain the same as the previous one.",
        "success"
      );
      handleOnClose();
      return;
    }

    api
      .patch(`/restaurant-management/orders/UpdateTableNumber/${order.id}`, {
        tableNumber,
      })
      .then(() => {
        addToast("Order Updated", "Order details successfully updated.", "success");
        refresh();
        dispatch(updateOrderDine({ id: order.id, tableNo: tableNumber }));
        handleOnClose();
      })
      .catch((error) => {
        addToast("Error", "Failed to update order details.", "error");
        console.log(error);
      });
  };

  const handleOnClose = () => {
    setTableNumber("");
    onClose();
    setStaffError(false);
    setTableError(false);
  };

  useEffect(() => {
    setTableNumber(order?.user?.tableNo);
  }, [order]);
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-addDishes">
      <div className="modal-content-addDishes" ref={modalRef}>
        <button className="close" onClick={handleOnClose}>
          <img src={cross} alt="cross" />
        </button>
        <div className="modal-confirm-header">
          <h6>Edit Details</h6>
        </div>
        <div className="content-details-dishes">
          <div className="orderIdDetails">
            <div className="orderId">
              <p>Order ID #{order.id}</p>
            </div>
            <div className="copyButton" onClick={() => handleCopy(order.id)}>
              <img src={copy} alt="copy" />
            </div>
          </div>
          <div className="customeDetails-orderType">
            <div className="CustomerDetails">
              <div className="OrderName">
                <p>{order.user.name}</p>
              </div>
              <div className="ordertimesdetails">
                <div className="time">
                  {convertToIST(order.createdTime).time}
                </div>
                <div className="seperation">|</div>
                <div className="orderdayDate">
                  {convertToIST(order.createdTime).date}
                </div>
              </div>
            </div>
            <div className="orderType">
              <p>{order.orderType.replace("Dine-in", "Dine In")}</p>
            </div>
          </div>
          <div className="itemDetails">
            {order.user.items.map((item) => (
              <div className="Single-Items">
                <p>{item.name}</p>
                <small>
                  {currency}
                  {item.price} | Qty: {item.quantity}
                </small>
              </div>
            ))}
          </div>
          <form>
              <label>Assign Table</label>
              <select
                name="Tablenumber"
                className="tableNumber"
                value={tableNumber}
                onChange={handleTableChange}
                style={{ border: tableError ? "1px solid red" : "" }}
              >
                <option value="" disabled>
                  Select Table
                </option>
                <option value="Table 1">Table 1</option>
                <option value="Table 2">Table 2</option>
                <option value="Table 3">Table 3</option>
                <option value="Table 4">Table 4</option>
              </select>
              {tableError && (
                <p className="error-message" style={{ textAlign: "left" }}>
                  Please select a table
                </p>
              )}
            </form>
            {/* <div className="setTimeEstimation">
              <button onClick={decrementTime}>-</button>
              <div>{time} mins</div>
              <button onClick={incrementTime}>+</button>
            </div> */}
            <div className="Action-button" style={{ marginTop: "2rem" }}>
              <button className="reject" onClick={handleOnClose}>
                Close
              </button>
              <button className="accept" onClick={handleAccept}>
                Update
              </button>
            </div>
        </div>
      </div>
    </div>
  );
}

export default EditDetailsDineIn;


